import { ValidationRuleFunction } from '@/support/ValidationRules';
import { Component, Prop, VModel, Vue } from 'vue-property-decorator';

@Component<SupplierSizeTextInput>({})
export default class SupplierSizeTextInput extends Vue {

  // #region @VModel

  @VModel()
  protected internalValue!: string;

  // #endregion

  // #region @PropSyncs
  // #endregion

  // #region @Props

  @Prop({ default: 'Supplier size' })
  protected label!: string;

  @Prop({ default: 'Supplier size' })
  protected placeholder!: string;

  @Prop({ default: () => [] })
  protected rules!: ValidationRuleFunction[];

  // #endregion

  // #region @Refs
  // #endregion

  // #region Props
  // #endregion

  // #region Plugin props
  // #endregion

  // #region Lifecycle hooks / Init
  // #endregion

  // #region Handlers
  // #endregion

  // #region Helpers
  // #endregion

  // #region API Requests
  // #endregion

  // #region Getters & Setters
  // #endregion

  // #region @Watchers
  // #endregion
}
